import { forwardRef, Link, LinkProps, useTheme } from '@chakra-ui/react';
import { Theme } from 'src/theme';
import {
  fillClassname,
  fillStyles,
  itemClassname,
  pillsClassname,
} from './constants';

export type NavLinkProps = Omit<LinkProps, 'textDecoration' | 'sx'>;

export const NavLink = forwardRef<LinkProps, 'a'>((props, ref) => {
  const theme = useTheme<Theme>();

  return (
    <Link
      color="neutral.500"
      display="block"
      px={4}
      py={2}
      tabIndex={0}
      _hover={{
        color: 'primary.500',
      }}
      _focus={{
        color: 'primary.500',
      }}
      {...props}
      ref={ref}
      textDecoration="none"
      sx={{
        [`.${pillsClassname} &`]: {
          borderRadius: 'full',
          boxShadow: '0px 2px 4px rgba(77, 38, 38, 0.15)',
          '.active': {
            boxShadow: 'inset 0px 0px 4px rgba(0, 0, 0, 0.25)',
            filter: 'grayscale(100%)',
          },
          ':not(.active):hover': {
            boxShadow: `0px 2px 4px ${theme.colors.primary[100]}`,
          },
        },
        [`.${fillClassname} > .&`]: fillStyles,
        [`.${fillClassname} .${itemClassname} &`]: {
          w: '100%',
        },
      }}
    />
  );
});
